import * as HttpService from './HttpService'

let namespace = 'budget'

let data = (params, cb, errorCb) => {
    HttpService.get(namespace + '/data', params, cb, errorCb)
}

let overview = (params, cb, errorCb) => {
    HttpService.get(namespace + '/overview', params, cb, errorCb)
}

let hours = (params, cb, errorCb) => {
    HttpService.get(namespace + '/hours', params, cb, errorCb)
}

let cph = (params, cb, errorCb) => {
    HttpService.get(namespace + '/cph', params, cb, errorCb)
}

let ebitda = (params, cb, errorCb) => {
    HttpService.get(namespace + '/ebitda', params, cb, errorCb)
}

let create = (body, cb, errorCb) => {
    HttpService.post(namespace + '/create', body, cb, errorCb)
}

export {
    data,
    overview,
    hours,
    cph,
    ebitda,
    create
}



// WEBPACK FOOTER //
// ./src/services/budgetService.js